import { useTranslation } from "react-i18next";

import { TableView } from "components";
import { Element } from "components/ReactScroll/index";

type VariablesProps = {
  tabId: string;
};

export const Variables = ({ tabId }: VariablesProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_variables", "Variables")}</h3>
      <div className="mt-25">
        <TableView
          cells={[
            "{{.Appointment.VIN}}",
            "{{.Customer.Title}}",
            "{{.Appointment.WONr}}",
            "{{.Customer.FullTitle}}",
            "{{.Appointment.CarMake}}",
            "{{.Customer.FirstName}}",
            "{{.Appointment.CarModel}}",
            "{{.Customer.Surname}}",
            "{{.Appointment.RegNumber}}",
            "{{.Link}}",
            "{{.Receptionist}}",
            "{{.Date}}"
          ]}
          nrOfCells={2}
          enableCopy
        />
      </div>
    </Element>
  );
};
